import type { Translations } from './de'

const en: Translations = {
  'language.flag': '🇬🇧',
  'language.name': 'English',
  'navigation.home': 'Home',
  'navigation.language': 'Language',
  'navigation.openMenu': 'Open menu',
  'navigation.closeMenu': 'Close menu',
  'navigation.skipToContent': 'Skip to content',
  'categories.sightseeing.name': 'Sightseeing',
  'categories.sightseeing.heading': 'The most popular sights in Augsburg',
  'categories.sightseeing.lead': 'From UNESCO World Heritage to the Fuggerei, Augsburg has more to offer than you think.',
  'categories.events.name': 'Events',
  'categories.events.heading': 'All events at a glance',
  'categories.events.lead': 'Concerts, markets, city tours: find out what is happening in Augsburg this week.',
  'categories.blog.name': 'News',
  'categories.blog.heading': 'News from Augsburg',
  'categories.blog.lead': 'Background stories, city history and current topics to read and to pass on.',
  'categories.emptyTitle': 'Nothing here yet',
  'categories.emptyDescription': 'There are no pages in this section yet. Check back soon.',
  'home.title': 'Welcome to Augsburg',
  'home.intro': 'Whether it is a city trip, a business trip or a family visit, here you will find all the important information for your time in Augsburg.',
  'home.sightseeing.eyebrow': 'UNESCO World Heritage city',
  'home.sightseeing.title': 'Discover the sights',
  'home.sightseeing.lead': 'From UNESCO World Heritage to the Fuggerei, Augsburg has more to offer than you think.',
  'home.sightseeing.action': 'Discover now',
  'home.events.eyebrow': 'What is on in Augsburg?',
  'home.events.title': 'Find events',
  'home.events.lead': 'Never miss a concert, flea market or festival again. Our events page always keeps you up to date.',
  'home.events.action': 'All events',
  'home.blog.eyebrow': 'Stories from the city',
  'home.blog.title': 'News and insights',
  'home.blog.lead': 'Here you will find everything important about Augsburg, so you are well informed during your visit.',
  'home.blog.action': 'To the blog',
  'home.language.eyebrow': 'Augsburg is international',
  'home.language.title': 'Switch to your language',
  'home.language.lead': 'This site is available in several languages. Would you like to switch the language?',
  'home.highlights.eyebrow': 'Curated for you',
  'home.highlights.title': 'Our recommendations',
  'home.highlights.lead': 'For a good start we have put together some highlights in Augsburg. Enjoy reading!',
  'search.placeholder': 'Search...',
  'search.clear': 'Clear search',
  'search.label': 'Search pages',
  'search.results': '{{count}} results for “{{query}}”',
  'search.emptyTitle': 'No results',
  'search.emptyDescription': 'We could not find anything for this search. Try a different term.',
  'pagination.label': 'Pages',
  'pagination.previous': 'Previous page',
  'pagination.next': 'Next page',
  'pagination.page': 'Page {{page}}',
  'pagination.summary': 'Showing {{start}}–{{end}} of {{total}}',
  'page.back': 'Back',
  'page.readMore': 'Read more',
  'page.tableOfContents': 'On this page',
  'page.openInGoogleMaps': 'Open in Google Maps',
  'map.copyAddress': 'Copy address',
  'map.copied': 'Copied',
  'map.copyFailed': 'Copying not possible',
  'map.routeInGoogleMaps': 'Route in Google Maps',
  'map.zoomIn': 'Zoom in',
  'map.zoomOut': 'Zoom out',
  'map.showAll': 'Show all',
  'attribution.toggle': 'Show or hide attribution',
  'map.gestures.windows': 'Use Ctrl + scroll to zoom the map',
  'map.gestures.mac': 'Use ⌘ + scroll to zoom the map',
  'map.gestures.mobile': 'Use two fingers to move the map',
  'map.loading': 'Loading map …',
  'map.failed': 'The map could not be loaded.',
  'map.showPlace': 'Show {{name}} on the map',
  'map.marker': '{{name}}, {{icon}}',
  'map.numberedMarker': '{{number}}. {{name}}, {{icon}}',
  'map.route.walkingTime': 'approx. {{duration}} on foot',
  'map.route.stops': '{{count}} stops',
  'map.route.leg': '{{distance}} · approx. {{duration}}',
  'mapIcons.landmark': 'Sight',
  'mapIcons.church': 'Church',
  'mapIcons.museum': 'Museum',
  'mapIcons.park': 'Park & nature',
  'mapIcons.viewpoint': 'Viewpoint',
  'mapIcons.cafe': 'Café',
  'mapIcons.bar': 'Bar',
  'mapIcons.restaurant': 'Restaurant',
  'mapIcons.shop': 'Shopping',
  'mapIcons.event': 'Venue',
  'mapIcons.transport': 'Transport',
  'mapIcons.place': 'Place',
  'footer.imprint': 'Legal notice',
  'footer.privacy': 'Privacy policy',
  'footer.mediaLicense': 'Image rights',
  'legal.bindingNote': 'This translation is provided for information only. Only the German version is legally binding.',
  'imprint.provider.heading': 'Information according to § 5 DDG',
  'imprint.contact.heading': 'Contact',
  'imprint.contact.email': 'Email',
  'imprint.responsible.heading': 'Responsible for content according to § 18 (2) MStV',
  'privacy.intro': 'This privacy policy explains which personal data is processed when you visit this website.',
  'privacy.controller.heading': 'Controller',
  'privacy.controller.text': 'The controller responsible for data processing on this website is:',
  'privacy.hosting.heading': 'Hosting',
  'privacy.hosting.text': 'This website is hosted by an external hosting provider based in Germany. The servers are located in Germany.',
  'privacy.serverLogs.heading': 'Server log files',
  'privacy.serverLogs.text': 'Each time you visit this website, the server automatically stores information transmitted by your browser: IP address, date and time of the request, requested page, amount of data transferred, referrer URL, and browser and operating system. This data is required to operate the website securely and reliably (Art. 6(1)(f) GDPR) and is deleted after 7 days at the latest.',
  'privacy.analytics.heading': 'Audience measurement',
  'privacy.analytics.text': 'To learn which pages are read, we count page views ourselves, without external services and without cookies. When you open a page, your browser only reports its address to our server. For each address, language and day, we store nothing but the number of views, split into browsers and automated programs (crawlers), which we tell apart by the browser identifier (user agent). Your IP address, browser identifier and other information about you are not stored for this, so no conclusions about individual visitors are possible. If your browser sends the “Global Privacy Control” or “Do Not Track” signal, your visit is not counted. The numbers are deleted after one year. The legal basis is Art. 6(1)(f) GDPR; our legitimate interest is improving this website.',
  'privacy.errorReports.heading': 'Error reports',
  'privacy.errorReports.text': 'If a technical error occurs while a page is loading, an email with information about the failed request is automatically sent to the operator. It may contain your IP address, the requested address and details about your browser. Error reports are used solely to fix errors (Art. 6(1)(f) GDPR).',
  'privacy.cookies.heading': 'Cookies',
  'privacy.cookies.text': 'This website only uses technically necessary cookies, which are required for your session and to protect against forged requests (CSRF). They contain no data for analytics or advertising and are deleted when you close your browser. The legal basis is § 25(2) no. 2 TDDDG in conjunction with Art. 6(1)(f) GDPR; no consent is required. No external analytics or tracking services are used; the audience measurement described above works without cookies.',
  'privacy.rights.heading': 'Your rights',
  'privacy.rights.text': 'You have the following rights:',
  'privacy.rights.access': 'access to your stored data (Art. 15 GDPR)',
  'privacy.rights.rectification': 'rectification (Art. 16 GDPR)',
  'privacy.rights.erasure': 'erasure (Art. 17 GDPR)',
  'privacy.rights.restriction': 'restriction of processing (Art. 18 GDPR)',
  'privacy.rights.portability': 'data portability (Art. 20 GDPR)',
  'privacy.rights.objection': 'objection to processing (Art. 21 GDPR)',
  'privacy.rights.contact': 'To exercise these rights, simply send an email to:',
  'privacy.complaint.heading': 'Right to lodge a complaint',
  'privacy.complaint.text': 'You have the right to lodge a complaint with a data protection supervisory authority. The competent authority is the Bavarian State Office for Data Protection Supervision (BayLDA), Promenade 18, 91522 Ansbach, Germany.',
  'privacy.updated': 'Last updated: October 2026',
  'mediaLicense.intro': 'All photos, videos, documents and routes on this website belong to Visit Augsburg. You may use, share and adapt them under the Creative Commons Attribution 4.0 International license (CC BY 4.0) – commercially, too – as long as you credit us as the source.',
  'mediaLicense.credit.heading': 'How to credit us',
  'mediaLicense.credit.text': 'Show this notice clearly, right next to the image or video:',
  'mediaLicense.credit.link': 'Where possible, link to the page the medium comes from and to the license. If you changed a medium, say so.',
  'mediaLicense.ai.heading': 'AI assistants and search engines',
  'mediaLicense.ai.text': 'This also applies to chatbots, AI assistants and search engines: whoever shows an image or video from this website shows the notice “{{credit}}” with it. Creator, notice and license are machine-readable in every image file (IPTC/XMP) and in the structured data (schema.org) of every page.',
  'mediaLicense.license.heading': 'License',
  'mediaLicense.license.text': 'The Creative Commons license text applies:',
  'mediaLicense.license.link': 'CC BY 4.0 – Attribution 4.0 International',
  'mediaLicense.scope.heading': 'What the license does not cover',
  'mediaLicense.scope.text': 'The texts of this website are not part of the license. The map data comes from OpenStreetMap and is available under the Open Database License (© OpenStreetMap contributors).',
  'mediaLicense.contact': 'Questions about using our media? Send an email to:',
  'mediaLicense.updated': 'Last updated: October 2026',
  'gallery.previous': 'Previous image',
  'gallery.next': 'Next image',
  'gallery.showImage': 'Show {{title}}',
  'video.play': 'Play {{title}}',
  'videoGallery.summaryOne': '1 video · {{minutes}} min',
  'videoGallery.summaryOther': '{{count}} videos · {{minutes}} min',
  'tags.unesco_heritage': 'UNESCO World Heritage',
  'tags.landmark': 'Landmark',
  'tags.church_monastery': 'Church & monastery',
  'tags.museum_culture': 'Museum & culture',
  'tags.park_nature': 'Park & nature',
  'tags.viewpoint': 'Viewpoint',
  'tags.accessible': 'Accessible',
  'tags.free': 'Free',
  'tags.family_friendly': 'Family-friendly',
  'tags.concert': 'Concert',
  'tags.market': 'Market',
  'tags.guided_tour': 'Guided tour',
  'tags.festival': 'Festival',
  'tags.exhibition': 'Exhibition',
  'tags.sports': 'Sports',
  'tags.open_air': 'Open air',
  'tags.city_history': 'City history',
  'tags.tips_tricks': 'Tips & tricks',
  'tags.interview': 'Interview',
  'tags.food_drink': 'Food & drink',
  'tags.seasonal': 'Seasonal',
  'tags.behind_the_scenes': 'Behind the scenes',
  'tags.event_recap': 'Event recap',
}

export default en
